import { Color } from '@celito.clients/theme';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTenantAdministrationLayoutStyles = makeStyles({
  shell: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f7fb',
    color: tokens.colorNeutralForeground1,
  },
  header: {
    height: '85px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding('0', '1.6rem'),
    backgroundImage: `linear-gradient(92deg, ${Color.dark_blue_gradiant} -2.93%, ${Color.light_bluen_gradiant} 103.99%)`,
    boxShadow: '0 1px 0 rgba(255, 255, 255, 0.12)',
    position: 'sticky',
    top: 0,
    zIndex: 20,
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: tokens.borderRadiusMedium,
    ':focus-visible': {
      outline: `2px solid ${tokens.colorNeutralForegroundOnBrand}`,
      outlineOffset: '4px',
    },
  },
  logo: {
    display: 'block',
    width: '12rem',
    height: 'auto',
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '40px',
    justifyContent: 'flex-end',
  },
  contentArea: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    width: '100%',
    overflow: 'hidden',
  },
  navigationDrawer: {
    width: '15rem',
    height: '100%',
    flexShrink: 0,
    overflow: 'hidden',
    backgroundColor: '#e7ebf2',
    ...shorthands.borderRight('1px', 'solid', tokens.colorNeutralStroke2),
  },
  collapsedNavigation: {
    width: '3.5rem',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    rowGap: '0.5rem',
    backgroundColor: '#e7ebf2',
    ...shorthands.borderRight('1px', 'solid', tokens.colorNeutralStroke2),
  },
  collapsedNavigationItem: {
    minWidth: 0,
    width: '100%',
    justifyContent: 'center',
  },
  navigationBody: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0.5rem',
    overflow: 'hidden',
    ...shorthands.padding('0'),
  },
  navigationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  navigationLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    ...shorthands.padding('0', '0', '0', '0.75rem'),
  },
  navigationItem: {
    width: '100%',
    justifyContent: 'flex-start',
    fontWeight: tokens.fontWeightSemibold,
  },
  navigationItemSelected: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
  },
  main: {
    minWidth: 0,
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  mainBody: {
    minHeight: 0,
    flex: 1,
    overflowY: 'auto',
    ...shorthands.padding('1.625rem', '1.625rem', '2.6875rem'),
  },
  footer: {
    '& div': {
      position: 'static',
    },
  },
});
